
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { fetchProductById } from "../api/products";
import { FaPlus, FaEdit } from "react-icons/fa";
import "../styles/Checkout.css";


export default function Checkout() {
  const navigate = useNavigate();
  const { state } = useLocation();

  const [cartItems, setCartItems] = useState([]);
  const [products, setProducts] = useState({});
  const [loading, setLoading] = useState(true);
  const [addresses, setAddresses] = useState([]); // multiple addresses
  const [form, setForm] = useState({
    name: "",
    email: "",
    address: "",
    city: "",
    country: "",
    postalCode: "",
    contact: "",
  });
  const [editing, setEditing] = useState(false); // editing mode
  const [errors, setErrors] = useState({});
  const [orderSuccess, setOrderSuccess] = useState(false);

  const userRes = JSON.parse(localStorage.getItem("user") || "{}");

  const [referralCode, setReferralCode] = useState("");
const [discountPercent, setDiscountPercent] = useState(0);
const [discountMessage, setDiscountMessage] = useState("");

// Function to check referral code
const checkReferral = async () => {
  try {
    const res = await fetch("https://biosurgebackend-1.onrender.com/api/referrals/check-referral", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ code: referralCode }),
    });

    const data = await res.json();

    if (data.success) {
      setDiscountPercent(data.discountPercent);
      setDiscountMessage(`Referral applied! ${data.discountPercent}% off`);
    } else {
      setDiscountPercent(0);
      setDiscountMessage("Invalid referral code");
    }
  } catch (err) {
    console.error("Referral error:", err);
    setDiscountMessage("Server error");
  }
};


  // Load cart items & addresses
  useEffect(() => {
    const loadCartAndAddress = async () => {
      try {
        // Cart items
        let items = Array.isArray(state) ? state : [];
        if (!Array.isArray(state) && userRes.id) {
          const res = await fetch(`https://biosurgebackend-1.onrender.com/api/cart/${userRes.id}`);
          items = await res.json();
        }
        setCartItems(items);

        // Product details
        const details = {};
        await Promise.all(
          items.map((item) =>
            fetchProductById(item.productId)
              .then((r) => (details[item.productId] = r.data))
              .catch((err) => console.error(err))
          )
        );
        setProducts(details);

        // Fetch saved address
        if (userRes.id) {
          const addrRes = await fetch(`https://biosurgebackend-1.onrender.com/api/users/${userRes.id}/address`);
          const addrData = await addrRes.json();
          if (Object.keys(addrData).length) {
            setAddresses([addrData]); // convert to array for multiple cards
          }
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    loadCartAndAddress();
  }, [state]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  };

  const validate = () => {
    const errs = {};
    if (!form.name) errs.name = "Required";
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(form.email)) errs.email = "Invalid email";
    if (!form.address) errs.address = "Required";
    if (!form.city) errs.city = "Required";
    if (!form.country) errs.country = "Required";
    if (!/^\d{6}$/.test(form.postalCode)) errs.postalCode = "PIN must be 6 digits";
    if (!form.contact) errs.contact = "Required";
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const saveAddress = async () => {
    if (!validate()) return false;
    try {
      await fetch(`https://biosurgebackend-1.onrender.com/api/users/${userRes.id}/address`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      setAddresses([form]);
      setEditing(false);
      return true;
    } catch (err) {
      console.error(err);
      return false;
    }
  };
  // Auto-fill form when address is fetched
useEffect(() => {
  if (addresses.length > 0 && !editing) {
    setForm(addresses[0]);
  }
}, [addresses, editing]);


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!(await saveAddress())) return;

    // Compute subtotal
// Calculate subtotal
const subtotal = cartItems.reduce((sum, item) => {
  const p = products[item.productId];
  if (!p) return sum;
  const variant = p.priceVariants.find(v => v.size === item.size);
  const unit = variant ? variant.price * (1 - (p.discount || 0) / 100) : 0;
  return sum + unit * item.qty;
}, 0);

// Apply referral discount if valid
const discountAmount = (subtotal * discountPercent) / 100;
const total = subtotal - discountAmount;



    const amountInPaise = Math.round(total * 100);

    // Razorpay order
    const orderResponse = await fetch("https://biosurgebackend-1.onrender.com/api/payment/order", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ amount: amountInPaise }),
    });
    const orderData = await orderResponse.json();

    const options = {
      key: "rzp_live_SJYD3uhb46qBo3",
      amount: orderData.amount,
      currency: "INR",
      name: "BioSurge",
      description: "Test Transaction",
      order_id: orderData.id,
      handler: async function (response) {
        await fetch("https://biosurgebackend-1.onrender.com/api/orders", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            userId: userRes.id,
            items: cartItems,
            shipping: form,
            totalAmount: total,
              referralCode: referralCode || null,
            paymentId: response.razorpay_payment_id,
            razorpayOrderId: response.razorpay_order_id,
            razorpaySignature: response.razorpay_signature,
          }),
        });
         if (referralCode && discountPercent > 0) {
    await fetch("https://biosurgebackend-1.onrender.com/api/referrals/use-referral", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ code: referralCode }),
    });
  }
        setOrderSuccess(true);
      },
      theme: { color: "#3dc74dff" },
    };
    const rzp = new window.Razorpay(options);
    rzp.open();
  };

  if (loading)
    return (
      <div className="cart-loading">
        <div className="spinner"></div>
        <p>Loading checkout…</p>
      </div>
    );

  if (orderSuccess)
    return (
      <div className="order-success">
        <h2>Order Placed Successfully!</h2>
        <h3>Track your order in your profile. Tracking Id and other details will be updated shortly.</h3>
        <button className="b1" onClick={() => navigate("/")}>Continue Shopping</button>
        <button className="b1" onClick={() => navigate(`/profile/${userRes.id}`)}>Track Order</button>
      </div>
    );
    

  return (
    <div className="checkout-container">
      <div className="checkout-grid">
       
        <aside className="order-summary">
           <h6 >By placing order you agree to our Terms, Privacy & Refund Policy</h6>
          <h2>Order Summary</h2>
          {cartItems.map((item) => {
  const p = products[item.productId];
  if (!p) return null;

  //  Fix for size-based pricing
  const variant = p.priceVariants.find(v => v.size === item.size);
  const unitPrice = variant ? variant.price * (1 - (p.discount || 0) / 100) : 0;
  const lineTotal = (unitPrice * item.qty).toFixed(2);

  return (

              <div className="order-item" key={item.productId}>
                <img
                  src={p.images[0]?.startsWith("http") ? p.images[0] : `https://biosurgebackend-1.onrender.com/ServiceProduct/${p.images[0]}`}
                  alt={p.title}
                />
                <div className="item-details">
                  <h4>{p.title}</h4>
                  <p>Qty: {item.qty}</p>
                  <p>Size: {item.size}</p>
                  <div className="item-price">₹{lineTotal}</div>
                </div>
              </div>
            );
          })}
         <div className="summary-row">
  <span>Subtotal:</span>
  <span>₹{cartItems.reduce((sum, item) => {
    const p = products[item.productId];
    if (!p) return sum;
    const variant = p.priceVariants.find(v => v.size === item.size);
    const unit = variant ? variant.price * (1 - (p.discount || 0) / 100) : 0;
    return sum + unit * item.qty;
  }, 0).toFixed(2)}</span>
</div>

{discountPercent > 0 && (
  <div className="summary-row">
    <span>Referral Discount ({discountPercent}%):</span>
    <span>-₹{((cartItems.reduce((sum, item) => {
      const p = products[item.productId];
      if (!p) return sum;
      const variant = p.priceVariants.find(v => v.size === item.size);
      const unit = variant ? variant.price * (1 - (p.discount || 0) / 100) : 0;
      return sum + unit * item.qty;
    }, 0) * discountPercent) / 100).toFixed(2)}</span>
  </div>
)}

<div className="summary-row total">
  <span>Total:</span>
  <span>₹{(cartItems.reduce((sum, item) => {
    const p = products[item.productId];
    if (!p) return sum;
    const variant = p.priceVariants.find(v => v.size === item.size);
    const unit = variant ? variant.price * (1 - (p.discount || 0) / 100) : 0;
    return sum + unit * item.qty;
  }, 0) * (1 - discountPercent / 100)).toFixed(2)}</span>
</div>

         <div className="referral-section">
  <label htmlFor="referralCode">Referral Code</label>
  <div className="referral-input-group">
    <input
      id="referralCode"
      type="text"
      value={referralCode}
      onChange={(e) => setReferralCode(e.target.value)}
      placeholder="Enter referral code"
    />
    <button type="button" onClick={checkReferral}>
      Apply
    </button>
  </div>
  {discountMessage && <p className="discount-msg">{discountMessage}</p>}
</div>


        </aside>

        <div className="checkout-form">
          <h2>Shipping Info</h2>

          {/* Show saved address as card */}
          {addresses.length > 0 && !editing && (
            <div className="address-card">
              <h4>{addresses[0].name}</h4>
              <p>{addresses[0].email}</p>
              <p>{addresses[0].address}, {addresses[0].city}, {addresses[0].country}</p>
              <p>PIN: {addresses[0].postalCode}</p>
              <p>Contact: {addresses[0].contact}</p>
              <button className="icon-btn" onClick={() => { setEditing(true); setForm(addresses[0]); }}>
                <FaEdit /> Edit
              </button>
            </div>
          )}

          {/* Address form */}
          {(editing || addresses.length === 0) && (
  <form onSubmit={async (e) => {
    e.preventDefault();
    if (editing) {
      await saveAddress(); // Just save, no payment
    } else {
      handleSubmit(e); // Save + Pay when no address exists
    }
  }}>
    {[
      ["name", "Full Name"],
      ["email", "Email"],
      ["address", "Address"],
      ["city", "City"],
      ["country", "Country"],
      ["postalCode", "PIN Code"],
      ["contact", "Contact"],
    ].map(([f, label]) => (
      <div className="form-group" key={f}>
        <label>{label}</label>
        <input
          name={f}
          value={form[f]}
          onChange={handleChange}
          className={errors[f] ? "error" : ""}
        />
        {errors[f] && <span className="error-msg">{errors[f]}</span>}
      </div>
    ))}

    {/* Button text depends on mode */}
    <button type="submit" className="checkout-btn">
      {editing ? "Save" : "Save & Pay"}
    </button>
  </form>
)}


          {/* Add another address button */}
        {addresses.length > 0 && !editing && (
  <button
    className="checkout-btn pay-now-btn"
    onClick={handleSubmit}
    style={{ marginTop: "10px", backgroundColor: "#3dc74d", color: "#fff" }}
  >
    Pay Now
  </button>
)}

        </div>
      </div>
    </div>
  );
}

